import { Core } from "@faire/design-tokens";
import { Pill } from "@faire/retailer-visitor-shared/components/LoggedOutPills/Pill";
import { discoverSearch } from "@faire/retailer-visitor-shared/lib/seoPaths";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { Carousel } from "@faire/web--source/slate-labs/Carousel/Carousel";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useQuery as usePopularSearchesQuery } from "@faire/web-api--source/endpoints/www/api/seo/popular-searches/get-hooks";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import capitalize from "lodash/capitalize";
import React, { useMemo } from "react";

const STALE_TIME = 1000 * 60 * 5;
export const MoreToExplorePills: React.FC = () => {
  const homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
  const { data } = usePopularSearchesQuery(
    {
      max_results: 20,
    },
    {
      refetchOnMount: false,
      staleTime: STALE_TIME,
    }
  );
  const ref = useDoActionWhenVisible(() =>
    trackLoggedOutRetailersLoggedOutHomeRedesignView(
      "perfect_product_banner-explore-more-pill",
      `${homepageRedesignVariant}`
    )
  );

  const popularSearchStrings = data?.queries;

  const pills = useMemo(() => {
    if (!popularSearchStrings?.length) {
      return [];
    }
    return popularSearchStrings.map((popularSearchString) => {
      return {
        pillContent: capitalize(popularSearchString),
        linkTo: discoverSearch(popularSearchString),
        onClick: () => {
          trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
            "perfect_product_banner-explore-more-pill",
            discoverSearch(popularSearchString),
            `${homepageRedesignVariant}`
          );
        },
      };
    });
  }, [popularSearchStrings, homepageRedesignVariant]);

  if (!pills?.length) {
    return null;
  }

  return (
    <Row
      data-test-id="more-to-explore-pills"
      align="center"
      className="w-full pl-6"
      ref={ref}
    >
      <Typography
        style={{ whiteSpace: "nowrap", paddingRight: getSpacing("2x") }}
        variant="paragraphSansMedium"
      >
        <StrictLocalMsg
          defaultMessage="More to explore"
          description={{
            text: "more to explore pills in bottom sign up banner",
            img: "https://cdn.faire.com/fastly/3be6a35cd5ed7c3a974fc9920bddd68dabe1bfa75f15c2f13d6ed2363b5bce40.png",
          }}
        />
      </Typography>
      <div style={{ overflow: "auto" }}>
        <Carousel
          items={pills}
          renderItem={(pill) => (
            <Pill pill={pill} style={{ marginRight: getSpacing("1x"), border: `1px solid ${Core.border.default}` }} className="hover:bg-core-surface-hover/5" />
          )}
          freeFlow
          showNavigationArrows={false}
          itemGap={{ mobileAndAbove: 0 }}
          loop={false}
          onVisible={() => {
            trackLoggedOutRetailersLoggedOutHomeRedesignView(
              "perfect_product_banner-explore-more-pill-onscroll"
            );
          }}
        />
      </div>
    </Row>
  );
};
